import { GeographicCategoriesComponent } from './../criterias/geographic-categories/geographic-categories.component';
import { Component, OnInit, Input, ViewChild, ComponentFactoryResolver, Injector, ViewContainerRef, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-blade',
  templateUrl: './blade.component.html',
  styleUrls: ['./blade.component.css']
})
export class BladeComponent implements OnInit {
  @Input() title: string;

  @ViewChild('dynamic', {
    read: ViewContainerRef
  }) viewContainerRef: ViewContainerRef

  private _component: any;
  get component() {
    return this._component;
  }
  @Input() set component(value) {
    this._component = value;
    this.loadBladeContents();
  }

  @Input() updater : any;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
    this.loadBladeContents();
  }

  loadBladeContents() {
    
    let x = this.component;
    this.viewContainerRef.clear();
    if (!x) 
      return;

    const factory = this.componentFactoryResolver.resolveComponentFactory(x)
    const component = factory.create(this.viewContainerRef.parentInjector);
    let comp : any;
    comp = component.instance;
    comp.updater = () => this.updater();
    comp.title = this.title;
    this.viewContainerRef.insert(component.hostView);
  }

  @Output() onCloseClicked: EventEmitter<any> = new EventEmitter<any>();

  handleCloseClick(){
    console.log("blade close click");
    this.onCloseClicked.emit();
  }
}
